import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Divider,
  UploadFile,
  FormInstance,
} from "antd";
import ImageUpload from "../../../Common/ImageUpload";
import { useTranslation } from "react-i18next";
import { UserCreateParams } from "../../../../hooks/api/users";
import { UserRoleType, UserStatusType } from "../../../../store/auth";
import dayjs, { Dayjs } from "dayjs";
import { enumToOptionsArray } from "../../../../utils";
import { UserPlanDisplay, UserRoleDisplay } from "../../../../enums/user";

export interface UserFormValues {
  // fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRoleType;
  phone: string;
  // avatar?: string;
  plan?: string;
  birthdate?: Dayjs | null;
  gender?: string;
  address?: string;
  country?: string;
  city?: string;
  zipCode?: string;
  // status?: UserStatusType;
}

export interface UsersFormProps {
  initialValues?: UserFormValues;
  form?: FormInstance<UserFormValues>;
  onSubmit?: (values: UserFormValues) => void | Promise<void>;
  fileList?: UploadFile[];
  setFileList: React.Dispatch<React.SetStateAction<UploadFile[]>>;
}

export default function UsersForm({
  // form,
  initialValues,
  fileList,
  setFileList,
  onSubmit,
}: UsersFormProps): React.ReactElement {
  // const [form] = Form.useForm<UserFormValues>();
  const form = Form.useFormInstance();
  // const [fileList, setFileList] = useState<UploadFile[]>([]);
  const { t } = useTranslation();

  // const handleFinish = async (values: UserFormValues) => {
  //   try {
  //     const payload: UserFormValues = {
  //       ...values,
  //       avatar: fileList ? fileList[0]?.url : "",
  //     };
  //     await onSubmit(payload);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };
  const mainFields = [
    {
      name: "firstName",
      label: "First Name",
      required: true,
      component: <Input />,
      rules: [
        {
          required: true,
        },
        {
          min: 3,
          message: `Must be at least 3 characters`,
        },
      ],
    },
    {
      name: "lastName",
      label: "Last Name",
      component: <Input />,
      required: true,
      rules: [
        {
          required: true,
        },
        {
          min: 3,
          message: `Must be at least 3 characters`,
        },
      ],
    },
    {
      name: "email",
      label: t("pages.users.form.email"),
      required: true,
      component: <Input placeholder={t("pages.users.form.enterPlaceholder")} />,
      rules: [
        {
          required: true,
        },
        {
          type: "email",
        },
      ],
    },
    {
      name: "role",
      label: t("pages.users.form.role"),
      required: true,
      component: (
        <Select
          placeholder="Select"
          options={enumToOptionsArray(UserRoleDisplay)}
        />
      ),
      rules: [
        {
          required: false,
        },
      ],
    },
  ];
  const renderFields = (fields: any[]) =>
    fields.map((f) => (
      <Col span={12} key={f.name}>
        <Form.Item name={f.name} label={f.label} rules={f.rules}>
          {f.component}
        </Form.Item>
      </Col>
    ));

  return (
    <>
      <Row gutter={24}>
        {/* <Col span={18}>
          <Row gutter={16}>{renderFields(mainFields)}</Row>
        </Col> */}
        {renderFields(mainFields)}
      </Row>
    </>
  );
}
